import React from 'react';
import { getInitials } from '../../../dashboard/components/shared/PatientItem';
import { formatDateTime, formatMoney } from '../utils';
import styles from '../Recovery.module.css';

const STATUS_CLASS = {
  queued: styles.statusQueued,
  sent: styles.statusSent,
  failed: styles.statusFailed,
  booked: styles.statusBooked,
  attended: styles.statusAttended,
};

const MESSAGE_SOURCE_TEXT = {
  ai: 'texto da IA',
  ai_edited: 'texto da IA, revisado',
  template_edited: 'modelo editado',
};

/**
 * Uma ação do painel de resultado: pessoa e horário guardado para oferecer,
 * razões, status real da mensagem, se a pessoa respondeu e o retorno
 * atribuído (quando houve).
 */
function ActionRow({ action }) {
  const openRecord = () => window.open(`/patients/${action.patientId}`, '_blank', 'noopener');
  const reasons = action.reasons || [];
  const attributed = action.attributedAppointment;
  // Respondeu e ainda não agendou: o convite não cita horário, a equipe oferece o guardado na ação
  const replied = Boolean(action.repliedAt) && !attributed && action.status !== 'failed';
  const slotAhead = action.slotStart && new Date(action.slotStart.replace(' ', 'T')) > new Date();

  return (
    <div className={styles.action}>
      <div className={styles.actionWho}>
        <span className={styles.avatar} aria-hidden="true">{getInitials(action.patientName)}</span>
        <div className={styles.actionCell}>
          <button type="button" className={styles.candidateName} onClick={openRecord} title="Abrir cadastro">
            {action.patientName}
          </button>
          <span className={styles.actionDetail}>
            {[formatDateTime(action.slotStart), action.professionalName, action.slotMinutes ? `${action.slotMinutes} min` : null]
              .filter(Boolean).join(' · ')}
          </span>
        </div>
      </div>

      <div className={styles.reasons}>
        {reasons.map((reason) => (
          <span
            key={reason.code}
            className={`${styles.reason} ${reason.code === 'no_pattern' ? styles.reasonNeutral : ''}`}
          >
            {reason.text}
          </span>
        ))}
      </div>

      <div className={styles.actionStatus}>
        <span className={`${styles.status} ${STATUS_CLASS[action.status] || styles.statusQueued}`}>
          {action.statusText || action.status}
        </span>
        {action.status === 'failed' && action.messageStatus?.error && (
          <span className={styles.actionError}>{action.messageStatus.error}</span>
        )}
        {replied && (
          <span className={styles.actionReplied}>
            Respondeu em {formatDateTime(action.repliedAt)}
            {slotAhead && ` · ofereça ${formatDateTime(action.slotStart)}`}
          </span>
        )}
        {attributed && (
          <span className={styles.actionDetail}>
            Agendou para {formatDateTime(attributed.date)}
            {action.attendedValue != null && ` · ${formatMoney(action.attendedValue)}`}
          </span>
        )}
        <span className={styles.actionDetail}>
          {formatDateTime(action.createdAt)}{action.createdByName ? ` por ${action.createdByName}` : ''}
          {MESSAGE_SOURCE_TEXT[action.messageSource] ? ` · ${MESSAGE_SOURCE_TEXT[action.messageSource]}` : ''}
        </span>
      </div>
    </div>
  );
}

export default ActionRow;
